.container :global(.react-icon) {
    line-height: 0;
}
